import { apiUserRegisterOcpc } from "@/services/index";
import { Message } from "element-ui";
const configInfo = {
  namespaced: true,
  state: {
    configInfoObj:{
       mobanType: "template_2"
    },
    jumpHomePage: "",
    copyRight: "",
  },
  getters: {
    pageTitle: (state) => state.pageTitle,
    configInfoObj: (state) => state.configInfoObj,
    webParam: (state) => {
      return state.configInfoObj.webParam ? JSON.parse(state.configInfoObj.webParam) : {};
    },
    jumpHomePage: (state) => state.jumpHomePage,
    copyRight: (state) => state.copyRight,
  },
  mutations: {
    updateConfigInfoObj(state, data) {
      state.configInfoObj = data;
    },
    updateJumpHomePage(state, data) {
      state.jumpHomePage = data;
    },
    updateCopyRight(state, data) {
      state.copyRight = data;
    },
  },
  actions: {
    // 获取配置信息
    async getConfigInfo(store, params) {
      const { code, data, msg } = await apiUserRegisterOcpc(params).then((res) => res);
      console.log(data);

      if (code === 200) {
        store.commit("updateConfigInfoObj", data);
      } else {
        Message.error(msg || `网络错误，请稍后重试[SERVER_ERR ${code}]`);
      }
    },
  },
};
export default configInfo;
